module.exports = __webpack_public_path__ + "img/symbol_0.1c8c7335.png";